import { useUnleash } from '@/package';

import VueronSprintContext from './context';
import type { VueronSprintContextValue } from './type';

const VueronSprintProvider = ({ children }: React.PropsWithChildren) => {
  const { getVariant, getVariantPayloadValue } = useUnleash();

  const getSprintFeatureMap = (sprintKey: string) =>
    (getVariantPayloadValue(sprintKey) ?? {}) as Dictionary<{
      disabled: boolean;
    }>;
  const isFeatureDisabled = (sprintKey: string, featureName: string) =>
    isSprintEnabled(sprintKey)
      ? (getSprintFeatureMap(sprintKey)?.[featureName].disabled ?? false)
      : true;
  const isSprintEnabled = (sprintKey: string) =>
    getVariant(sprintKey)?.feature_enabled ?? false;

  return (
    <VueronSprintContext.Provider<VueronSprintContextValue>
      value={{
        getSprintFeatureMap,
        isFeatureDisabled,
        isSprintEnabled,
      }}
    >
      {children}
    </VueronSprintContext.Provider>
  );
};

VueronSprintProvider.displayName = 'VueronSprintProvider';

export default VueronSprintProvider;
